export const LANGUAGES = [
  { label: "English", code: "en", id: 120000000 }, 
  { label: "Arabic", code: "ar", id: 120000006 }, 
  { label: "Chinese", code: "ch", id: 120000011 }, 
  { label: "Polish", code: "pl", id: 120000003 }, 
  { label: "Russian", code: "rs", id: 120000010 },
  { label: "Spanish", code: "es", id: 120000001 }, 
  { label: "Ukrainian", code: "ur", id: 120000016 }, 
];
